<span class="dclose-button" (click)="onCloseBtn()">
  <mat-icon>close</mat-icon>
</span>

<mat-form-field class="no-line custom-select pd-left">
  <mat-label>{{ 'selectMapType' | translate }}</mat-label>
  <mat-select [(value)]="data.selectedMapval" (selectionChange)="onMapChange($event)" panelClass="map-panel-up"
 id="dmap-select-width">
    <mat-select-trigger>
      {{ getSelectedOptionLabel() }}
    </mat-select-trigger>

    <ng-container *ngFor="let option of options">
      <mat-option *ngIf="option.isVisible(data)" [value]="data.mapTypes[option.value]"
        [class.custom-selected-option]="data.selectedMapval === data.mapTypes[option.value]"
        [class.custom-image-option]="option.value === 'CustomImage'">
        <div class="option-content">
          <span class="option-label">{{ option.label | translate }}</span>
          <span *ngIf="option.value === 'CustomImage'" class="option-subtitle">{{ 'design.leftPanel.mapOption.uImageSubtitle' | translate }}</span>
        </div>
      </mat-option>
    </ng-container>

  </mat-select>
</mat-form-field>

<div mat-dialog-content class="dialog-msg">
  <p class="alert-description">{{'noteDeletion' | translate }}</p>
</div>
<div mat-dialog-actions class="button-container">
  <button mat-button class="button no-button" (click)="onNoClick()">{{'buttons.cancel' | translate }}</button>
  <button mat-button class="button yes-button" (click)="onYesClick()">{{'buttons.confirm' | translate}}</button>
</div>